module.exports = __webpack_public_path__ + "media/1_1-35.99b3c25b.mp3";